import Big from 'big.js';

// FIXME: Once decimal128 is available replace big.js
// @see https://tc39.es/proposal-decimal/
export const preciseAverageWithNull = (values: (number | null | undefined)[]) => {
  const allNumbers = values.every(
    (value) => value === null || value === undefined || typeof value === 'number',
  );

  if (!allNumbers) {
    return null;
  }

  return values
    .reduce((acc, current) => {
      if (current === null) {
        return acc.plus(0);
      }

      if (typeof current === 'number') {
        return acc.plus(current);
      }
      return acc;
    }, Big(0))
    .div(values.length || 1)
    .toNumber();
};
